import React from 'react'
import styled from '@emotion/styled'

import {NoStyleLink} from '@vio/atlas/helpers/NoStyleLink'
import {Icon, IconName} from '@vio/atlas/Icon'
import {cssTheme} from '@vio/atlas/themes'

interface Props {
  url?: string
  iconName: IconName
}

export const FooterSocialButton = ({url, iconName}: Props) => {
  if (!url) {
    return null
  }
  return (
    <SocialLink href={url} target="_blank" aria-label={iconName}>
      <Icon name={iconName} size="lg" colorPath={'content.neutral.primary'} />
    </SocialLink>
  )
}

const SocialLink = styled(NoStyleLink)`
  height: ${cssTheme.layout.spacing.s800};
  width: ${cssTheme.layout.spacing.s800};
  border-radius: 50%;
  background-color: ${cssTheme.colors.background.neutral.primary};
  display: flex;
  justify-content: center;
  align-items: center;
`
